import { useEffect } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

let lenisInstance = null;
export const getLenis = () => lenisInstance;

/**
 * Lenis momentum scrolling for mouse wheels (touch scrolling stays native).
 * Disabled for visitors who prefer reduced motion.
 *
 * On every navigation: if the address has a #section, scroll to it once it
 * exists (works for links from other pages and for direct visits such as
 * /demo#twin); otherwise go to the top of the new page.
 */
export function SmoothScroll({ children }) {
  const location = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ lerp: 0.12, smoothWheel: true, wheelMultiplier: 1 });
    lenisInstance = lenis;
    let frame;
    const raf = (time) => { lenis.raf(time); frame = requestAnimationFrame(raf); };
    frame = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(frame); lenis.destroy(); lenisInstance = null; };
  }, []);

  useEffect(() => {
    const id = decodeURIComponent(location.hash.replace("#", ""));
    if (!id) {
      if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
      return undefined;
    }
    let tries = 0;
    let timer;
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 80;
        if (lenisInstance) lenisInstance.scrollTo(top, { immediate: tries === 0 });
        else window.scrollTo(0, top);
        if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
        el.focus({ preventScroll: true });
        return;
      }
      if (tries++ < 30) timer = setTimeout(attempt, 60);
    };
    timer = setTimeout(attempt, 0);
    return () => clearTimeout(timer);
  }, [location.key]); // eslint-disable-line react-hooks/exhaustive-deps

  return children;
}
